<!-- <h1 mat-dialog-title>
  Chi ha sviluppato questo software?
</h1> -->

<mat-dialog-content class="mb-3">
  <div class="row">
    <div class="col-12 text-center mb-3" style="min-height: 70px;">
      <img src="/assets/img/logo-sitisrl.png" alt="SITI srl" width="70">
    </div> <!-- /.col-12 -->
    <div class="col-12 text-justify">
      <p>
        {{ 'dialogs.sitisrl.p1' | translate }}
        <strong>{{ configService.developerFullName }}</strong>{{ 'dialogs.sitisrl.p2' | translate }}
        <strong>{{ configService.developerName }}</strong>{{ 'dialogs.sitisrl.p3' | translate }}
      </p>
      <p class="text-center">
        <a href="https://sitisrl.it/web-agency-milano?utm_source=archedi" target="_blank">{{ configService.developerWebsite }}</a>
      </p>
    </div> <!-- /.col-12 -->
  </div> <!-- /.row -->
</mat-dialog-content> <!-- mat-dialog-content -->

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onClose()">
    <mat-icon fontSet="fal" fontIcon="fa-times-circle"></mat-icon>
    {{ 'common.cta.close' | translate }}
  </button>
</mat-dialog-actions> <!-- /.mat-dialog-actions -->
